import React from 'react';
import { Box, Heading, Spacer, Stack, Text } from '@chakra-ui/react';
import { useInView } from 'react-intersection-observer';
import { CountUp } from '../components';
import { Grid, GridItem } from '@chakra-ui/react';
import { STAT } from 'Constants';
import { ILandingPageLayoutChild } from 'Layouts/LandingPageLayout';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const STATSection = ({ shouldIgnoreParentPadding }: ILandingPageLayoutChild) => {
	const { ref, inView } = useInView({
		threshold: 0,
	});

	return (
		<Stack
			bg="#FFEEEC"
			spacing={10}
			textAlign={['left','center']}
			ref={ref}
			py="28"
			px={['8', '14']}
		>
			<Box w={['100%','', '70%']} m="0 auto">
				<Heading fontSize={['24px','','50px']}>Meet the world’s greatest shoppers.</Heading>
				<Spacer h={10}/>
				<Text color="#586068">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea
				</Text>
			</Box>
			
			{inView ? (
				<Grid templateColumns={['repeat(1, 1fr)','repeat(3, 1fr)']} gap={6}>
					{STAT.map(({ value, text, unit }) => (
						<GridItem key={text} w="100%" >
							<CountUp fontSize={['60px','90px']} speed={10} end={value} postfix={unit} />
							<Text>{text}</Text>
						</GridItem>
					))}
				</Grid>
			): (
				<Grid templateColumns={['repeat(1, 1fr)','repeat(3, 1fr)']} gap={6}>
					{STAT.map(({ value, text, unit }) => (
						<GridItem key={text} w="100%" >
							<Heading fontSize={['60px','90px']}>{value} {unit}</Heading>
							<Text>{text}</Text>
						</GridItem>
					))}
				</Grid>
			)}
		</Stack>
	);
};
